import type { Coordinates } from '../types';

export function readGeolocationAccuracyM(position: GeolocationPosition): number | null {
  const acc = position.coords.accuracy;
  return typeof acc === 'number' && Number.isFinite(acc) ? acc : null;
}

/** Map browser GeolocationPosition → store coordinates + horizontal accuracy (meters) when available. */
export function mapPositionToCoordinates(position: GeolocationPosition): Coordinates {
  const acc = readGeolocationAccuracyM(position);
  return {
    lat: position.coords.latitude,
    lng: position.coords.longitude,
    ...(acc != null ? { accuracyM: acc } : {}),
  };
}
